<template>
  <div class="my-[12px] flex justify-center gap-x-[6px] relative">
    <CarouselMulti
      ref="carouselMultiRef"
      :slidesToShow="slidesToShow"
      :cardWidth="88"
      :total="segments.length"
    >
      <div
        v-for="(seg, index) in segments"
        :key="seg.start_time"
        class="p-[4px] h-[54px] w-[88px] rounded-[10px] border-[1px] border-solid cursor-pointer hover:border-primary"
        :class="[activeIndex === index ? 'border-primary' : 'border-transparent']"
        @click="onClick(seg.start_time)"
      >
        <img
          class="w-full h-full rounded-[8px] object-contain bg-[var(--back-1)]"
          :src="transformImage(seg.image_url, { height: 45 }).replace('_png', '_jpg')"
        />
      </div>
    </CarouselMulti>
  </div>
</template>

<script setup lang="ts">
// todo div 宽度是硬代码，要跟父级 video 一样
import { transformImage } from '~/utils';

const props = withDefaults(
  defineProps<{
    segments?: Array<{
      start_time: number;
      image_url: string;
    }>;
  }>(),
  {
    segments() {
      return [];
    },
  },
);

const carouselMultiRef = ref();
const currentTime = defineModel<number>('currentTime', { required: true });

function onClick(time: number) {
  currentTime.value = time;
}

const activeIndex = computed(() => {
  for (let i = 0; i < props.segments.length; i++) {
    const curr = props.segments[i];
    const next = props.segments[i + 1];
    if (!next) {
      return i;
    }
    if (currentTime.value >= curr.start_time && currentTime.value < next.start_time) {
      return i;
    }
  }
  return 0;
});

watch(
  () => activeIndex.value,
  index => {
    carouselMultiRef.value?.goTo(index);
  },
);

watch(
  () => props.segments,
  () => {
    carouselMultiRef.value?.reset();
  },
);

const slidesToShow = computed(() => {
  if (props.segments.length <= 6) {
    return props.segments.length;
  }
  return 6;
});
</script>
